export interface WorkItemType {
  type_key: string;
  name: string;
  icon?: string;
  is_deleted?: boolean;
  [key: string]: any;
}

export const IWorkItemTypeService = Symbol('IWorkItemTypeService')

export interface IWorkItemTypeService {
  // observable 属性
  workItemTypeList: WorkItemType[];
  // 过滤后的可用类型（排除 chart、sub_task、no_permission），用于 ScheduleLinkedSubWorkItem 等需要过滤的场景
  availableWorkItemTypes: WorkItemType[];

  getAll(projectKey: string, needVirtual?: boolean): Promise<WorkItemType[]>;
}
